import bookingService from '@/api/booking.service'

const actions = {
  getCategoryList: (context, companyId) => {
    let bookingListLoaded = new Promise((resolve, reject) => {
      bookingService
        .getCategoryList(context, companyId)
        .then(response => {
          context.commit('categoryList', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return bookingListLoaded
  },
  createProduct: (context, model) => {
    let product = new Promise((resolve, reject) => {
      bookingService
        .createProduct(context, model)
        .then(response => {
          resolve(response)
        })
        .then(() => {
          context.commit('bookingList')
        })
        .catch(e => {
          reject(e)
        })
    })
    return product
  },
  createCategory: (context, model) => {
    let category = new Promise((resolve, reject) => {
      bookingService
        .createCategory(context, model)
        .then(response => {
          context.dispatch('getCategoryList', model.companyId)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return category
  },
  updateCategory: (context, model) => {
    let category = new Promise((resolve, reject) => {
      bookingService
        .updateCategory(context, model)
        .then(response => {
          context.dispatch('getCategoryList', model.companyId).then(() => {
            resolve(response)
          })
        })
        .catch(e => {
          reject(e)
        })
    })
    return category
  },
  reorderCategory: (context, model) => {
    let category = new Promise((resolve, reject) => {
      bookingService
        .reorderCategory(context, model)
        .then(response => {
          context.dispatch('getCategoryList', model.companyId).then(() => {
            resolve(response)
          })
        })
        .catch(e => {
          reject(e)
        })
    })
    return category
  },
  deleteProduct: (context, model) => {
    let category = new Promise((resolve, reject) => {
      bookingService
        .deleteProduct(context, model)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return category
  }
}

export default actions
